import { render } from "./ContractRegistrationAdd.vue?vue&type=template&id=6e211f96"
import script from "./ContractRegistrationAdd.vue?vue&type=script&lang=js"
export * from "./ContractRegistrationAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__